export var DEFAULT_NUMBER_OF_NIGHTS = 1;
export var DEFAULT_BOOKINGCHANNEL = 'WEB';
export var DEFAULT_MULTI_SEARCH_ROOM = {
  adultsNumber: 1,
  childrenNumber: 0,
  type: 'DB'
};
export var SEARCH_RESULTS_PAGE_SIZE_REDIS_TTL = 60 * 60;